export const chartColorCodes = [
  { key: '5', value: '#78c8a1' },
  { key: '4', value: '#aed787' },
  { key: '3', value: '#ffd834' },
  { key: '2', value: '#ffb234' },
  { key: '1', value: '#ff8b5a' },
];
